import _ from "lodash";

export function translate(text, ...args) {
	let translate = _.get(window.translate, text);

	if(translate === undefined) {
		return text;
	}

	const tags = args[0];
	for(var i in tags) {
		translate = translate.replace(new RegExp(i, 'g'), tags[i]);
	}

	return translate;
}


// WEBPACK FOOTER //
// ./src/addons/Translate.js